import { REGISTER_EMPLOYEE, SET_PASSWORD } from '../../resources/endPoint';

export const registerEmployee = data => {
    console.log(data, 'data printed');

    return {
        url: REGISTER_EMPLOYEE,
        payload: data,
        method: 'post',
        //   tag: ApiTag.CSRF_TOKEN,
        headers: { 'content-type': 'application/json' },
        authRequired: false,
        csrfToken: true,
    };
};

export const setPassword = (data) => {
    return {
        url: SET_PASSWORD,
        payload: data,
        method: 'post',
        //    tag: ApiTag,
        headers: { 'content-type': 'application/json' },
        authRequired: false,
        csrfToken: true,
    };
};
